/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import currency from "currency.js";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { Fragment } from "react";
import CurrencyFormat from "react-currency-format";
import { isArrayNotEmpty, isStringNotEmpty } from "utils/empty-exists";
import DisplayTextOnlyWrapper from "cms/fields/layout/controls/display-text-wrapper";

const CurrencyFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    // Docs: https://currency.js.org/
    const currencyOptions = { separator: ",", decimal: ".", format: formatFunc };
    
    function formatFunc (currency) {
        return `${currency.dollars()}.${currency.cents()}`;
    }
    
    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style } = settings || {};
                    const currencyValue = currency(value, currencyOptions).format();
                    const formattedStyle = isStringNotEmpty(style) && style.replace("field.style.", "");
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnlyWrapper
                                key={index}
                                style={formattedStyle}
                            >
                                <CurrencyFormat
                                    variant='standard'
                                    value={currencyValue}
                                    displayType={"text"}
                                    decimalSeparator={"."}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                />
                            </DisplayTextOnlyWrapper>
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
CurrencyFieldDisplay.displayName = "CurrencyFieldDisplay";
export { CurrencyFieldDisplay };
